/* GUDUGU THUNDER — LIGHT THEME JS */
(function(){
'use strict';

/* ── RAIN + LIGHTNING STORM ── */
const hero = document.querySelector('.hero');
const rainC = hero ? hero.querySelector('#rain-canvas') : null;
const stormC = hero ? hero.querySelector('#storm-canvas') : null;

if(rainC && stormC && hero){
  function resizeC(){
    rainC.width = stormC.width = hero.offsetWidth;
    rainC.height = stormC.height = hero.offsetHeight;
  }
  resizeC();
  window.addEventListener('resize', resizeC);

  const rctx = rainC.getContext('2d');
  const drops = Array.from({length:160},()=>({
    x:Math.random()*2000, y:Math.random()*1200,
    len:Math.random()*18+8, spd:Math.random()*4+3,
    op:Math.random()*.15+.03
  }));
  (function drawRain(){
    rctx.clearRect(0,0,rainC.width,rainC.height);
    drops.forEach(d=>{
      rctx.strokeStyle='rgba(26,24,20,'+d.op+')';
      rctx.lineWidth=.6; rctx.beginPath();
      rctx.moveTo(d.x,d.y); rctx.lineTo(d.x+d.len*.2,d.y+d.len); rctx.stroke();
      d.y+=d.spd; d.x+=d.spd*.2;
      if(d.y>rainC.height+20){d.y=-20;d.x=Math.random()*rainC.width;}
      if(d.x>rainC.width+20){d.x=-20;}
    });
    requestAnimationFrame(drawRain);
  })();

  const sctx = stormC.getContext('2d');
  function zigzag(x1,y1,x2,y2,off,depth){
    if(depth<=0||Math.hypot(x2-x1,y2-y1)<3){sctx.moveTo(x1,y1);sctx.lineTo(x2,y2);return;}
    const mx=(x1+x2)/2+(Math.random()-.5)*off, my=(y1+y2)/2+(Math.random()-.5)*off*.3;
    zigzag(x1,y1,mx,my,off/2,depth-1); zigzag(mx,my,x2,y2,off/2,depth-1);
    if(Math.random()>.65&&depth>2) zigzag(mx,my,mx+(Math.random()-.5)*60,my+Math.random()*70,off/3,depth-2);
  }
  function flashBolt(fromX){
    const cx = fromX !== undefined ? fromX : Math.random()*stormC.width;
    const destY = stormC.height*(0.45+Math.random()*.4);
    sctx.strokeStyle='rgba(255,255,255,0.92)'; sctx.lineWidth=2.5;
    sctx.beginPath(); zigzag(cx,0,cx+(Math.random()-.5)*80,destY,55,8); sctx.stroke();
    setTimeout(()=>{
      sctx.clearRect(0,0,stormC.width,stormC.height);
      sctx.strokeStyle='rgba(200,150,10,0.8)'; sctx.lineWidth=1.2;
      sctx.beginPath(); zigzag(cx,0,cx+(Math.random()-.5)*70,destY,50,8); sctx.stroke();
      setTimeout(()=>sctx.clearRect(0,0,stormC.width,stormC.height),90);
      const prev = hero.style.background;
      hero.style.background='rgba(252,250,242,0.96)';
      setTimeout(()=>hero.style.background=prev,65);
    },38);
  }
  let lastB=0, nb=Math.random()*3500+1500;
  (function loop(ts){
    if(ts-lastB>nb){flashBolt();lastB=ts;nb=Math.random()*3500+1500;}
    requestAnimationFrame(loop);
  })(0);
  hero.addEventListener('click',(e)=>{
    /* Don't trigger bolt when clicking the unmute button */
    if(e.target.closest('.video-sound-toggle')) return;
    const r=hero.getBoundingClientRect(); flashBolt(e.clientX-r.left);
  });
}

/* ── VIDEO UNMUTE TOGGLE ── */
const video = document.getElementById('brand-video');
const soundToggle = document.getElementById('video-sound-toggle');
if(video && soundToggle){
  const iconMuted = soundToggle.querySelector('.vs-muted');
  const iconUnmuted = soundToggle.querySelector('.vs-unmuted');
  const label = soundToggle.querySelector('.vs-label');

  soundToggle.addEventListener('click', function(e){
    e.preventDefault();
    e.stopPropagation();
    if(video.muted){
      video.muted = false;
      video.volume = 1.0;
      /* Try to play in case autoplay was paused */
      const p = video.play();
      if(p && p.catch) p.catch(()=>{});
      soundToggle.classList.add('is-unmuted');
      if(iconMuted) iconMuted.style.display = 'none';
      if(iconUnmuted) iconUnmuted.style.display = 'block';
      if(label) label.textContent = 'SOUND ON';
      /* Auto-fade the button after 2.5 seconds when unmuted */
      setTimeout(()=>soundToggle.classList.add('is-faded'), 2500);
    } else {
      video.muted = true;
      soundToggle.classList.remove('is-unmuted','is-faded');
      if(iconMuted) iconMuted.style.display = 'block';
      if(iconUnmuted) iconUnmuted.style.display = 'none';
      if(label) label.textContent = 'TAP FOR SOUND';
    }
  });

  /* Show button briefly on hover even after fading */
  soundToggle.addEventListener('mouseenter', ()=>soundToggle.classList.remove('is-faded'));
  soundToggle.addEventListener('mouseleave', ()=>{
    if(soundToggle.classList.contains('is-unmuted')){
      setTimeout(()=>soundToggle.classList.add('is-faded'), 800);
    }
  });
}

/* ── TITLE GLITCH ── */
const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ#@&%!';
document.querySelectorAll('.title-line').forEach(el=>{
  const orig = el.dataset.orig || el.textContent;
  let iv;
  el.addEventListener('mouseenter',()=>{
    let c=0;
    iv=setInterval(()=>{
      el.textContent=orig.split('').map((ch,i)=>i<c?ch:chars[Math.floor(Math.random()*chars.length)]).join('');
      c+=.6; if(c>=orig.length){el.textContent=orig;clearInterval(iv);}
    },38);
  });
  el.addEventListener('mouseleave',()=>{clearInterval(iv);el.textContent=orig;});
});

/* ── SCROLL REVEAL ── */
document.querySelectorAll('.story-grid,.song-card,.form-wrap,.bengaluru-stamp').forEach(el=>el.classList.add('reveal'));
const obs = new IntersectionObserver(entries=>{entries.forEach(e=>{if(e.isIntersecting)e.target.classList.add('visible');});},{threshold:.15});
document.querySelectorAll('.reveal').forEach(el=>obs.observe(el));

/* ══════════════════════════════════════
   AUDIO PLAYER — Scroll-triggered
   Auto-plays when song section scrolls into view,
   pauses when scrolled past. Play/pause btn still works.
   ══════════════════════════════════════ */
(function(){
  var audio = document.getElementById('gudugu-audio');
  var playBtn = document.getElementById('song-play-btn');
  var songSection = document.querySelector('.song-section');
  var barsEl = document.getElementById('song-bars');
  var playIcon = playBtn ? playBtn.querySelector('.sp-play') : null;
  var pauseIcon = playBtn ? playBtn.querySelector('.sp-pause') : null;

  if(!audio || !playBtn || !songSection) return;

  function setPlaying(playing){
    if(playing){
      playBtn.classList.add('is-playing');
      if(playIcon) playIcon.style.display='none';
      if(pauseIcon) pauseIcon.style.display='';
      if(barsEl) barsEl.classList.remove('paused');
    } else {
      playBtn.classList.remove('is-playing');
      if(playIcon) playIcon.style.display='';
      if(pauseIcon) pauseIcon.style.display='none';
      if(barsEl) barsEl.classList.add('paused');
    }
  }

  // Manual play/pause toggle
  playBtn.addEventListener('click', function(){
    if(audio.paused){ audio.play().catch(function(){}); }
    else { audio.pause(); }
  });

  audio.addEventListener('play', function(){ setPlaying(true); });
  audio.addEventListener('pause', function(){ setPlaying(false); });

  // Scroll-triggered: play when section is ≥40% visible, pause when it leaves
  var userPaused = false;
  playBtn.addEventListener('click', function(){
    // Track manual pause so scroll doesn't override it immediately
    userPaused = !audio.paused; // will be paused after click
  });

  var songObs = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){
        userPaused = false;
        audio.play().catch(function(){});
      } else {
        if(!userPaused) audio.pause();
      }
    });
  }, { threshold: 0.4 });

  songObs.observe(songSection);
  setPlaying(false);
})();

/* ══════════════════════════════════════
   FORM → GOOGLE SHEETS
   The Apps Script URL comes from Shopify
   theme settings via window.GUDUGU_SHEET_URL
   ══════════════════════════════════════ */
var SHEET_URL = window.GUDUGU_SHEET_URL || '';

const form = document.getElementById('interest-form');
const successBox = document.getElementById('form-success');

if(form){
  form.addEventListener('submit', function(e){
    e.preventDefault();
    const em = document.getElementById('field-email');
    if(!em || !em.value.includes('@')){
      em.style.borderColor='#c0392b'; em.focus(); return;
    }
    em.style.borderColor='';
    const sb = document.getElementById('form-submit-btn');
    const txt = sb ? sb.querySelector('.submit-text') : null;
    if(sb){ sb.disabled=true; if(txt) txt.textContent='LOCKING YOU IN...'; }

    const payload = {
      timestamp: new Date().toLocaleString('en-IN', {timeZone:'Asia/Kolkata'}),
      name: (form.querySelector('[name="name"]')||{}).value||'',
      email: em.value.trim(),
      handle: (form.querySelector('[name="handle"]')||{}).value||'',
      tshirt: ((form.querySelector('[name="tshirt"]:checked')||{}).value)||'',
      size: ((form.querySelector('[name="size"]:checked')||{}).value)||'',
      vibe: (form.querySelector('[name="vibe"]')||{}).value||''
    };

    if(SHEET_URL && SHEET_URL.startsWith('https://')){
      fetch(SHEET_URL, {
        method: 'POST',
        mode: 'no-cors',
        headers: {'Content-Type': 'text/plain'},
        body: JSON.stringify(payload)
      }).catch(()=>{});
    }

    setTimeout(()=>{
      form.style.display='none';
      if(successBox){ successBox.style.display='block'; }
    }, 900);
  });
}

})();
